import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

    private expanded: boolean = false;
    
    setExpanded(flag) {
        this.expanded = flag;
    }

    getExpanded() {
        return this.expanded;
    }
}
